import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { CompoundEntityDetail } from "./components/CompoundEntityDetail";
import { CompoundEntitiesContainer } from "./components/compoundEntities.container";

function CompoundEntityDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.compoundEntities.detail);
  const navigate = useNavigate();
  return <CompoundEntityDetail id={id} onBack={() => navigate("..")} />;
}

export function CompoundEntitiesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<CompoundEntitiesContainer />} />
        <Route path=":id" element={<CompoundEntityDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
